export default [
	{ label: 'Type', key: 'type' },
	{ label: 'Event', key: 'event' },
	{ label: 'DirectorName', key: 'directorName' },
	{ label: 'DirectorPhoneNumber', key: 'directorPhoneNumber' },
	{ label: 'DirectorUSBCMemberID', key: 'directorUSBCMemberID' },
	{ label: 'DirectorSSOUserId', key: 'directorSSOUserId' },
	{ label: 'DirectorSSOEmail', key: 'directorSSOEmail' },
	{ label: 'EventEmail', key: 'eventEmail' },
	{ label: 'DirectorAddressLine1', key: 'directorAddressLine1' },
	{ label: 'DirectorAddressLine2', key: 'directorAddressLine2' },
	{ label: 'DirectorCity', key: 'directorCity' },
	{ label: 'DirectorState', key: 'directorState' },
	{ label: 'DirectorCountry', key: 'directorCountry' },
	{ label: 'DirectorZipCode', key: 'directorZipCode' },
	{ label: 'CertificationNumber', key: 'certificationNumber' },
	{ label: 'StartDate', key: 'startDate' },
	{ label: 'EndDate', key: 'endDate' },
	{ label: 'CenterCertificationNumber', key: 'centerCertificationNumber' },
	{ label: 'CenterName', key: 'centerName' },
	{ label: 'Address', key: 'address' },
	{ label: 'City', key: 'city' },
	{ label: 'State', key: 'state' },
	{ label: 'Country', key: 'country' },
	{ label: 'ZipCode', key: 'zipCode' },
	{ label: 'Duration', key: 'duration' },
	{ label: 'IsSetupComplete', key: 'isSetupComplete' },
	{ label: 'SetupCompletionDate', key: 'setupCompletionDate' },
	{ label: 'ResultsSubmittedOn', key: 'resultsSubmittedOn' },
	{ label: 'ResultsSubmittedBy', key: 'resultsSubmittedBy' },
	{ label: 'Step', key: 'step' },
	{ label: 'LastStepCompleted', key: 'lastStepCompleted' },
	{ label: 'NumberOfGames', key: 'numberOfGames' },
	{ label: 'NumberOfWeeks', key: 'numberOfWeeks' },
	{ label: 'EventStatus', key: 'eventStatus' },
	{ label: 'RulesUploadedOn', key: 'rulesUploadedOn' },
	{ label: 'RulesApprovedOn', key: 'rulesApprovedOn' },
	{ label: 'RulesApprovedBy', key: 'rulesApprovedBy' },
	{ label: 'RulesUploadedNotificationSentOn', key: 'rulesUploadedNotificationSentOn' },
	{ label: 'RulesApprovedEmailSentOn', key: 'rulesApprovedEmailSentOn' },
	{ label: 'OffersScholarship', key: 'offersScholarship' },
	{ label: 'SmartProviderId', key: 'smartProviderId' },
	{ label: 'DepositReceivedEmailSentOn', key: 'depositReceivedEmailSentOn' },
	{ label: 'FinalStandingsUploadedOn', key: 'finalStandingsUploadedOn' },
	{ label: 'FinalStandingsUploadedEmailSentOn', key: 'finalStandingsUploadedEmailSentOn' },
	{ label: 'DepositAmount', key: 'depositAmount' },
	{ label: 'DepositPaidOn', key: 'depositPaidOn' },
  { label: 'AdvancerRatio', key: 'advancerRatio' },
  { label: 'IncludeEnhancedAdvancerRatio', key: 'includeEnhancedAdvancerRatio' },
	{ label: 'DivisionOffered', key: 'divisionOffered' },
	{ label: 'FeePaidOn', key: 'feePaidOn' },
	{ label: 'FeeAmount', key: 'feeAmount' },
	{ label: 'SpotsOffered', key: 'spotsOffered' },
	{ label: 'DivisionHeld', key: 'divisionHeld' },
	{ label: 'EDHGirls', key: 'edhGirls' },
	{ label: 'EDHBoys', key: 'edhBoys' },
	{ label: 'Mixed', key: 'mixed' },
	{ label: 'EDHCBoys', key: 'edhcBoys' },
	{ label: 'EDHCGirls', key: 'edhcGirls' },
	{ label: 'IsOrphan', key: 'isOrphan' },
	{ label: 'NumberSpots', key: 'numberSpots' },
	{ label: 'Day', key: 'day' },
	{ label: 'CreatedBy', key: 'createdBy' },
	{ label: 'CreatedDate', key: 'createdDate' },
	{ label: 'UpdatedBy', key: 'updatedBy' },
	{ label: 'UpdatedDate', key: 'updatedDate' },
	{ label: 'TypeName', key: 'typeName' },
	{ label: 'LowerRatio', key: 'lowerRatio' },
	{ label: 'UpperRatio', key: 'upperRatio' }
 ]


// WEBPACK FOOTER //
// ./src/containers/reports/constants/eventsHeaders.js